import { useEffect } from 'react'
import { Tree } from 'antd'
import { YhBox } from "@/components/YhBox";
import { fieldSetModel } from "../fieldSetModel";
import type { TreeProps } from 'antd/es/tree';
import '../fieldSet.less'

export const Left = () => {

  const { settleTreeData, selectedSettle, setSelectedSettle } = fieldSetModel()

  useEffect(() => {
    if (settleTreeData?.length > 0) {
      setSelectedSettle(settleTreeData[0]);
    }
  }, [settleTreeData])

  const onSelect: TreeProps['onSelect'] = (selectedKeys, info) => {
    setSelectedSettle(info.selectedNodes[0]);
  };

  return (
    <YhBox width="100%" style={{ height: '100vh' }} title="选择结算">
      <Tree
        className="p-5"
        treeData={settleTreeData}
        selectedKeys={[selectedSettle?.key ?? ""]}
        onSelect={onSelect}
      />
    </YhBox>
  )
}